import { Card, Box, Typography, Stack, Grid } from "@mui/material";
import moment from "moment";
import { Woman, Man } from "iconsax-react";
import helpTooltip from "../../../../static/img/icons/help-tooltip.svg";

const CardListStep3 = ({
  getFilterBySegmentType = () => {},
  userData,
  segmentType,
}) => {
  return (
    getFilterBySegmentType(userData, segmentType).length > 0 && (
      <>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: "16px",
            color: "#101828",
            marginTop: "30px",
          }}
        >
          {segmentType === "Others" ? "Empty Room" : segmentType}
        </Typography>
        <hr />
        <div
          style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
        >
          {getFilterBySegmentType(userData, segmentType).map((user) => (
            <Card
              sx={{
                background: "#FFFFFF",
                border: "1px solid #D0D5DD",
                borderRadius: "8px",
                width: "516px",
                height: "auto",
                marginRight: "20px",
                marginBottom: "20px",
              }}
            >
              <div>
                <Grid container>
                  <Grid item md={4}>
                    <Box
                      sx={{
                        background: "#F9FAFB",
                        borderRadius: "8px",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "16px",
                          color: "#344054",
                        }}
                      >
                        {user?.Name}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item md={4}>
                    <Grid container>
                      <Grid item md={10}>
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            color: "#344054",
                          }}
                        >
                          {user.RoomType__c}
                        </Typography>
                      </Grid>
                      <Grid item md={2}>
                        <Box
                          sx={{
                            background: "#F2F4F7",
                            borderRadius: "16px",
                            textAlign: "center",
                            width: "53px",
                            height: "22px",
                            padding: "2px 8px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "12px",
                              color: "#667085",
                            }}
                          >
                            {segmentType}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                    <Typography
                      sx={{
                        color: "#667085",
                        fontSize: "12px",
                        fontWeight: 300,
                      }}
                    >
                      {`(${moment(user.Start_Date__c).format(
                        "DD/MMM/YYYY"
                      )} - ${moment(user.End_Date__c).format("DD/MMM/YYYY")})`}
                    </Typography>
                  </Grid>
                  <Grid item md={4}>
                    <Stack direction="row" gap={1} sx={{ marginLeft: "40px" }}>
                      <Typography
                        sx={{
                          fontWeight: 300,
                          fontSize: "14px",
                          color: "#667085",
                        }}
                      >
                        {user.Sharing_Type__c}
                      </Typography>
                      <img src={helpTooltip} />
                    </Stack>
                  </Grid>
                </Grid>
              </div>
              <hr />
              {/* Card Content */}
              <div style={{ padding: "8px" }}>
                <Stack direction="row" gap={1}>
                  {user?.segments?.map((segment) => (
                    <>
                      <Box
                        sx={{
                          padding: "6px 16px 6px 8px",
                          background:
                            segment.Guest_ID__r.Guest_FullName__r?.Gender__c ===
                            "Female"
                              ? "#ECEDF8"
                              : "#EFFCF9",
                          border:
                            segment.Guest_ID__r.Guest_FullName__r?.Gender__c ===
                            "Female"
                              ? "1px solid #2F37B5"
                              : "1px solid #8CE2E3",
                          color:
                            segment.Guest_ID__r.Guest_FullName__r?.Gender__c ===
                            "Female"
                              ? "#00023F"
                              : "#134264",
                          borderRadius: "999px",
                          width: "auto",
                          height: "40px",
                        }}
                      >
                        <Stack direction="row" gap={1}>
                          {segment.Guest_ID__r?.Guest_FullName__r?.Gender__c ===
                          "Female" ? (
                            <Woman
                              color="#134264"
                              style={{
                                padding: "4px",
                                background: "#FFFFFF",
                                borderRadius: "1332px",
                              }}
                            />
                          ) : (
                            <Man
                              color="#134264"
                              style={{
                                padding: "4px",
                                background: "#FFFFFF",
                                borderRadius: "1332px",
                              }}
                            />
                          )}
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "16px",
                              color:
                                segment.Guest_ID__r.Guest_FullName__r
                                  ?.Gender__c === "Female"
                                  ? "#00023F"
                                  : "#134264",
                            }}
                          >
                            {segment.Guest_ID__r.Guest_FullName__r?.Name}
                          </Typography>
                        </Stack>
                      </Box>
                      {/* ))} */}
                    </>
                  ))}
                </Stack>
              </div>
              {/* Footer */}
              <div style={{ padding: "8px" }}>
                <Typography
                  sx={{ fontWeight: 400, fontSize: "14px", color: "#475467" }}
                >
                  <b>Remarks: {user.Remarks__c}</b>
                </Typography>
              </div>
            </Card>
          ))}
        </div>
      </>
    )
  );
};
export default CardListStep3;
